/* eslint-disable */
/* Code generated by generate-angular-formgroups.mjs DO NOT EDIT. */
import { signal, WritableSignal } from '@angular/core';
import { form, email, maxLength, minLength, required, SchemaPathTree } from '@angular/forms/signals';
import { LexplusAuthenticationRequestDto } from '../models';

/** Initial value for the signal model. */
export function getLexplusAuthenticationRequestDtoInitialValue(): LexplusAuthenticationRequestDto {
  return {
  email: '',
  password: '',
  otpCode: '',
  appDeviceId: '',
  forAdmin: false,
} as LexplusAuthenticationRequestDto;
}

/**
 * Reusable Signal Forms schema for LexplusAuthenticationRequestDto.
 * Can be passed to form() directly or embedded via apply()/applyEach().
 */
export function lexplusAuthenticationRequestDtoSchema(path: SchemaPathTree<LexplusAuthenticationRequestDto>): void {
  required(path.email);
  email(path.email);
  minLength(path.email, 5);
  maxLength(path.email, 255);
  required(path.password);
  minLength(path.password, 8);
}

/**
 * Creates the model signal and the form in one call.
 * The model signal is needed for submit(), for example: submit(field, { action }).
 */
export function createLexplusAuthenticationRequestDtoForm(initial?: Partial<LexplusAuthenticationRequestDto>) {
  const model: WritableSignal<LexplusAuthenticationRequestDto> = signal<LexplusAuthenticationRequestDto>({
    ...getLexplusAuthenticationRequestDtoInitialValue(),
    ...initial,
  } as LexplusAuthenticationRequestDto);
  return { model, field: form(model, lexplusAuthenticationRequestDtoSchema) };
}
